<template>
<div>
  <h1>Signup</h1>
  <form action="javascript:void(0);">
    <label>Email Address:</label>
    <input v-model="formEmail" type='text'>
    <button class="btn-secondary" @click="getEmail(formEmail)">Next</button>

    <span v-show="emailAlreadyRegistered">Account already exists with that email address. login here</span>
  </form>
  <form action="javascript:void(0);">


    <label>First Name:</label>
    <input v-model="formFirstName" type='text'>
    <label>Last Name:</label>
    <input v-model="formLastName" type='text'>
    <label>Password:</label>
    <input v-model="formPassword" type='password'>
    <button class="btn-secondary" @click="createUser()">Next</button>
  </form>
</div>
</template>

<script>
export default {
  data() {
    return {
      formEmail: "",
      formFirstName: "",
      formLastName: "",
      formPassword: "",
      emailAlreadyRegistered: false
    };
  },
  computed: {},
  methods: {
    getEmail: function(email) {
      this.$store.dispatch("users/emailExists", { email }).then(r => {
        this.emailAlreadyRegistered = r;
      });
    },
    createUser: function() {
      this.$store
        .dispatch("users/create", {
          email: this.formEmail,
          firstName: this.formFirstName,
          lastName: this.formLastName,
          password: this.formPassword
        })
        .then(r => {
          this.$store.dispatch("users/login", {
            email: this.formEmail,
            password: this.formPassword
          });
        });
    }
  },
  components: {},
  mounted: function() {}
};
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/signup.vue